/**
 * 코인 한글명 매핑 — 메인 페이지/시세/티커바 공통 사용
 *
 * ⚠️ 신규 코인/주식 추가 시 반드시 한글명 매핑 확인 필요
 *    - 프론트: 이 파일 COIN_NAMES_KR 에 추가
 *    - 백엔드: sisegonggan.ticker_map DB 테이블에 name 컬럼 업데이트
 *    (매핑 없으면 티커바에 코드(KRW-XXX)로 노출됨)
 */
export const COIN_NAMES_KR: Record<string, string> = {
  'KRW-BTC': '비트코인',
  'KRW-ETH': '이더리움',
  'KRW-XRP': '리플',
  'KRW-SOL': '솔라나',
  'KRW-ADA': '에이다',
  'KRW-DOGE': '도지코인',
  'KRW-DOT': '폴카닷',
  'KRW-AVAX': '아발란체',
  'KRW-MATIC': '폴리곤',
  'KRW-LINK': '체인링크',
  'KRW-TRX': '트론',
  'KRW-LTC': '라이트코인',
  'KRW-ATOM': '코스모스',
  'KRW-SHIB': '시바이누',
  'KRW-NEAR': '니어프로토콜',
  'KRW-ARB': '아비트럼',
  'KRW-OP': '옵티미즘',
  'KRW-SUI': '수이',
  'KRW-APT': '앱토스',
  'KRW-PEPE': '페페',
  'KRW-ETC': '이더리움클래식',
  'KRW-BCH': '비트코인캐시',
  'KRW-HBAR': '헤데라',
  'KRW-ALGO': '알고랜드',
  'KRW-XLM': '스텔라루멘',
  'KRW-SAND': '샌드박스',
  'KRW-AXS': '엑시인피니티',
  'KRW-MANA': '디센트럴랜드',
  'KRW-CHZ': '칠리즈',
  'KRW-APE': '에이프코인',
};

/** KRW-BTC → BTC */
export function stripKrw(ticker: string): string {
  return ticker.startsWith('KRW-') ? ticker.slice(4) : ticker;
}

/** "비트코인 (BTC)" 형식 */
export function coinDisplay(ticker: string, fallbackName?: string | null): string {
  const symbol = stripKrw(ticker);
  const name = COIN_NAMES_KR[ticker] ?? fallbackName ?? symbol;
  return `${name} (${symbol})`;
}
